import { FileDownload, KeyboardArrowRight, MoreHoriz } from "@mui/icons-material";
import { Box, Button, Card, CircularProgress, Grid2, IconButton, Typography } from "@mui/material";
import ChatContent from "components/ChatContent";
import Container from "components/Container";
import Loading from "components/Loading";
import useIndexedDB from "hooks/useIndexedDB";
import Main from "layouts/Main";
import React from "react";
import { useTranslation } from "react-i18next";
import { AccountContext } from "services/account";
import { exportChatHistory, getAllLastMessages } from "services/api";
import { showSnackbar } from "services/snackbarHelper";
import { Channel } from "types/channel";

const Chats = () => {
	const { t } = useTranslation(["common"]);
	const account = React.useContext(AccountContext);
	const [channels, setChannels] = React.useState<Channel[]>([]);
	const [isLoading, setLoading] = React.useState(true);
	const [isExporting, setIsExporting] = React.useState(false);

	const exportChats = () => {
		setIsExporting(true);
		exportChatHistory([account.value.userId])
			.then((resp) => {
				console.log(resp);
				if (!resp || resp?.error) return;
				showSnackbar(t(resp.message, { ns: "validation" }), "success");
			})
			.finally(() => setIsExporting(false));
	};

	React.useEffect(() => {
		setLoading(true);
		getAllLastMessages()
			.then((resp) => {
				console.log(resp);
				if (!resp || resp?.error) return;
				setChannels(resp.messages);
			})
			.finally(() => setLoading(false));
	}, []);

	return (
		<Main title={t("allChannels")}>
			{isLoading ? (
				<Loading />
			) : (
				<Container>
					<Box
						mb={1}
						width={1}
						display="flex"
						justifyContent={"flex-end"}>
						<Button
							disabled={isExporting}
							variant="contained"
							onClick={exportChats}
							startIcon={<FileDownload />}>
							{t("exportAllChatHistory")}
						</Button>
					</Box>
					{channels.length === 0 ? (
						<Typography textAlign={"center"}>{t("noChat")}</Typography>
					) : (
						channels.map((channel) => {
							return (
								<Box my={1}>
								<Box
									key={channel.channel}
									component="a"
									href={"/app/chat/" + channel.channel}
									overflow={"hidden"}>
									<Card sx={{ "&:hover": { bgcolor: "rgba(255, 255, 255, 0.08)" } }}>
										<Box
											px={2}
											py={1}>
											<ChatContent channel={channel} />
										</Box>
									</Card>
								</Box>
								</Box>
							);
						})
					)}
				</Container>
			)}
		</Main>
	);
};

export default Chats;
